export const staticFunctions = {
  addDevicesClasses() {
    var body = document.getElementsByTagName("BODY")[0];
    body.classList.add((typeof document.body.ontouchstart == "undefined") ? "no-touch" : "touch");
    if ((/iP/i.test(navigator.userAgent)))
        body.classList.add("ios");
  },
  setBrowserInfo() {
    const ua = navigator.userAgent; let tem;
    let M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
    if (/trident/i.test(M[1])) {
      tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
      return { name: 'IE ', version: (tem[1] || '') };
    }
    if (M[1] === 'Chrome') {
      tem = ua.match(/\bOPR\/(\d+)/);
      if (tem != null) {
        return { name: 'Opera', version: tem[1] };
      }
    }
    M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, '-?'];
    tem = ua.match(/version\/(\d+)/i);
    if (tem != null) {
      M.splice(1, 1, tem[1]);
    }
    // version: M[1].toLowerCase(),
    document.body.classList.add(M[0].toLowerCase());
  }
};


// WEBPACK FOOTER //
// ./assets/js/modules/module.js